module.exports = __webpack_public_path__ + "img/2.8b9db555.png";